import { render } from "./AuditTable.vue?vue&type=template&id=91971faa"
import script from "./AuditTable.vue?vue&type=script&lang=js"
export * from "./AuditTable.vue?vue&type=script&lang=js"

import "./AuditTable.vue?vue&type=style&index=0&id=91971faa&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__